
import { Options, Vue } from 'vue-class-component';
import store from '@/store';
import { StorageServices } from '@/services/StorageServices';
import { CommonServices } from '@/services/CommonServices';
import { LocalizedEntityClient } from '@/services/Services';

@Options({})
export default class LanguageSelector extends Vue {

    isActive: boolean = false;

    get enabledLanguages(): string[] {
        return store.state.company?.enabledLanguages || [];
    }

    get selectedLanguage(): string {
        return store.state.user?.preferredCulture || this.enabledLanguages[0] || 'it-IT';
    }

    get selectedFlag(): string {
        return this.getFlagFromLang(this.selectedLanguage);
    }

    getFlagFromLang(lang: string): string {
        // it-IT -> IT, en-US -> US, fr-FR -> FR, de-DE -> DE, es-ES -> ES
        return lang.substring(3, 5);
    }

    selectLanguage(lang: string) {
        store.state.user.preferredCulture = lang;
        StorageServices.setLoggedUser(store.state.user);
        CommonServices.setLanguage(lang);

        // Ricarica le traduzioni per la nuova lingua
        LocalizedEntityClient.getAllApp(store.state.appCode)
            .then((translations) => {
                store.state.consts.localizedValues = translations;
            });

        this.isActive = false;
    }
}
